// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/customer/left-img.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../images/customer/right-img.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/lato);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html,
header,
footer,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
li,
p,
section,
main {
  margin: 0px;
  padding: 0px;
  display: block;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:focus-visible {
  outline: -webkit-focus-ring-color auto 0px;
}

button:focus,
.btn-close:focus,
.btn-check:focus + .btn,
.btn:focus,
.accordion-button:focus,
.form-check-input:focus,
.form-control:focus {
  box-shadow: none;
}

body {
  overflow-x: hidden;
}

a {
  text-decoration: none;
}

a,
svg,
i {
  transition: 0.6s all ease-in-out;
}

@media (min-width: 1200px) {
  .container {
    max-width: 1280px;
  }
}

img {
  max-width: 100%;
  height: auto;
  object-fit: cover;
}

.z-index-9 {
  z-index: 9;
}

.inner-page {
  margin-top: 120px;
}

.min-height-0 {
  min-height: 0 !important;
}

.content {
  display: none;
}

.max-width-auto {
  max-width: inherit !important;
}

.bg-none {
  background: none !important;
}

/*Typography*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 700 !important;
}

h1 {
  font-size: 64px;
  line-height: 67px;
  font-weight: 900;
}

h2 {
  font-size: 36px !important;
  line-height: 35px;
  color: #010404;
}

h2 span {
  color: #163873;
}

h3 {
  font-size: 36px;
  line-height: 40px;
}

h4 {
  font-size: 32px;
  line-height: 48px;
}

h5 {
  font-size: 26px;
  line-height: 24px;
}

h6 {
  font-size: 16px;
  line-height: 20px;
}

p {
  color: var(--Black, #010404);
  text-align: justify;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin-bottom: 17px;
}

.font-size-14 {
  font-size: 14px;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.primary-color {
  color: #549cac;
}

/*Button*/
.btn {
  border-radius: 10px;
  padding: 13px 20px 12px;
  transition: 0.6s all ease-in-out;
}

.btn:hover {
  border: none;
  background-color: #000;
  color: #fff;
}

.btn_primary {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 20px !important;
  border-radius: 10px !important;
  background: #163873 !important;
  color: var(--White, #fff) !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: normal !important;
}

.btn-common {
  border-radius: 0px 0px 20px 20px !important;
}

.btn_secondary {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 20px !important;
  border-radius: 10px !important;
  border: 1px solid #163873 !important;
  background: var(--White, #fff) !important;
  color: #163873 !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: normal !important;
}

.btn.btn-donate {
  background-color: #408817;
}

.btn.btn-donate:hover {
  background-color: #419f0b;
}

.btn.btn-default {
  background-color: #549cac;
}

.btn.btn-default:hover {
  background-color: #c44d07;
}

.btn.btn-search {
  background-color: #549cac;
}

.btn.btn-search:hover {
  background-color: #403d3e;
}

.btn.btn-outline-default {
  border: 2px solid #549cac;
  color: #549cac;
  text-transform: capitalize;
}

.btn.btn-outline-default:hover {
  background-color: #c44d07;
  border: 2px solid #c44d07;
  color: #fff;
}

.btn.btn-outline-default svg {
  fill: #549cac;
  margin-left: 2px;
}

.btn.btn-outline-default:hover svg {
  fill: #fff;
}

.ascending-btn {
  transform: rotate(-180deg);
}

.cursor-pointer {
  cursor: pointer;
}

/*Custom Pagination*/
.custom-pagination .pagination {
  margin-top: 50px;
}

.custom-pagination .page-item:first-child .page-link,
.custom-pagination .page-item:last-child .page-link {
  border-radius: 0;
  font-size: 16px;
  border-top: 2px solid transparent;
  display: flex;
  align-items: center;
}

.custom-pagination .page-item:first-child .page-link svg {
  fill: #9ca3af;
  margin-right: 12px;
}

.custom-pagination .page-item:last-child .page-link svg {
  fill: #9ca3af;
  margin-left: 12px;
}

.custom-pagination .page-item:first-child .page-link:hover svg,
.custom-pagination .page-item:last-child .page-link:hover svg {
  fill: #549cac;
}

.custom-pagination .page-link {
  border: 0;
  border-radius: 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: #6b7280;
  border-top: 2px solid transparent;
  padding: 16px 16px 0 16px;
}

.custom-pagination .page-link.active,
.custom-pagination .page-link:hover,
.custom-pagination .page-link:focus {
  background-color: transparent;
  color: #549cac;
  border-top: 2px solid #549cac;
}

/*Custom Breadcrumb*/
nav[aria-label="breadcrumb"] {
  max-width: 732px;
  margin: 0px auto;
}

nav[aria-label="breadcrumb"] .custom-breadcrumb .breadcrumb-item {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

nav[aria-label="breadcrumb"] .custom-breadcrumb .breadcrumb-item a {
  color: #6b7280;
}

nav[aria-label="breadcrumb"] .custom-breadcrumb .breadcrumb-item:hover a {
  color: #549cac;
}

nav[aria-label="breadcrumb"] .custom-breadcrumb .breadcrumb-item.active {
  color: #549cac;
}

nav[aria-label="breadcrumb"]
  .custom-breadcrumb
  .breadcrumb-item
  + .breadcrumb-item::after {
  content: var(--bs-breadcrumb-divider, ">");
}

nav[aria-label="breadcrumb"]
  .custom-breadcrumb
  .breadcrumb-item:last-child::after {
  display: none;
}

nav[aria-label="breadcrumb"]
  .custom-breadcrumb
  .breadcrumb-item
  + .breadcrumb-item {
  padding-left: 23px;
}

nav[aria-label="breadcrumb"]
  .custom-breadcrumb
  .breadcrumb-item
  + .breadcrumb-item::before {
  padding-right: 23px;
}

/*Contact Form*/
.contact-form .form-control {
  background: #f9fdff;
  border: 1px solid #d1d5db;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  font-size: 16px;
  line-height: 24px;
  height: 50px;
  color: rgba(82, 84, 100, 0.8);
}

.contact-form .form-control::placeholder {
  font-size: 16px;
  line-height: 24px;
  color: rgba(82, 84, 100, 0.8);
}

.contact-form .form-group {
  margin-bottom: 24px;
}

/*Desktop Search*/
.dt-search {
  margin-bottom: 60px;
}

.dt-search .form-group {
  display: flex;
  align-items: center;
}

.dt-search .form-control {
  font-size: 19px;
  line-height: 24px;
  color: #6b7280;
  background: #f9fdff;
  border: 1px solid #d1d5db;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  height: 57px;
  margin-right: 17px;
}

.dt-search .search-label {
  width: 52px;
  height: 52px;
  background: #549cac;
  border-radius: 50%;
  padding: 12px;
  cursor: pointer;
}

.dt-search .search-label svg {
  fill: #ffffff;
}

.dt-search .search-label:hover svg {
  fill: #111827;
}

.form-select:focus {
  box-shadow: none !important;
  outline: 0 !important;
}

/*Sroll to top*/
.scrollTop {
  z-index: 99;
  cursor: pointer;
  border: none;
  position: fixed;
  bottom: 15px;
  right: 15px;
  width: 50px;
  height: 50px;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  background: #163873;
  transition: 0.6s all ease-in-out;
  border-radius: 40px;
}

.scrollTop:hover {
  background: #221c1d;
}

.scrollTop .fa-angle-up {
  color: #ffffff;
  transition: 0.6s all ease-in-out;
}

.scrollTop:hover .fa-angle-up {
  color: #ffffff;
}

.overlay {
  background: rgba(26, 25, 25, 0.8);
  width: 13%;
  height: 100%;
  position: fixed;
  z-index: 99;
  top: 0;
  right: 0;
  transition: 0.6s all ease-in-out;
}

hgroup.heading h3 {
  color: #549cac;
  margin-bottom: 16px;
}

hgroup.heading p {
  font-size: 20px;
  line-height: 28px;
}

.btn-close {
  right: 15px;
  top: 15px;
  z-index: 11;
  /* background: transparent url(../images/icons/modal-close-btn.svg); */
  padding: 0;
  width: 40px;
  height: 40px;
  opacity: 1;
}

.pattern {
  position: absolute;
  width: 100%;
  /* background: url(../images/pattern-img-1.png) no-repeat right; */
  height: 88px;
  left: 0;
  bottom: 0;
}

.intervation-bg {
  /* background: url(../images/intervation-bg.png) no-repeat; */
  background-size: cover;
  background-position: bottom;
}

.intervation-pattern {
  /* background: url(../images/intervation-pattern.png) no-repeat right bottom; */
  background-size: cover;
  height: 80px;
}

.carousel-indicators [data-bs-target] {
  width: 10px !important;
  height: 10px !important;
  background-color: #e5e7eb;
  border-radius: 50%;
  margin: 0 5px;
  opacity: 1;
  border: 5px solid transparent;
  transition: 0.6s all ease-in-out;
}

/*Custom Carousel*/
.carousel-control-next,
.carousel-control-prev {
  opacity: 1;
  cursor: default;
}

.carousel-control-next:focus .carousel-control-next-icon,
.carousel-control-next:hover .carousel-control-next-icon,
.carousel-control-prev:focus .carousel-control-prev-icon,
.carousel-control-prev:hover .carousel-control-prev-icon {
  opacity: 0.8;
}

.carousel-control-next-icon,
.carousel-control-prev-icon {
  width: 58px;
  height: 58px;
  cursor: pointer;
  position: absolute;
  /* display: none ; */
}


.pic_item .carousel-control-prev, 
.pic_item .carousel-control-next {
   display:  none;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}
.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;

}
.carousel-control-prev .carousel-items-icons {
  display: none !important;
}

a:link {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}

.css-1aquho2-MuiTabs-indicator {
  background-color: #163873 !important;
}

.css-187mznn-MuiSlider-root {
  color: #163873 !important;
}
.css-14owq8c-MuiButtonBase-root-MuiTab-root.Mui-selected {
  color: #163873 !important;
}

.page-flex,
.sidebar-user-img picture,
.users-table picture {
  display: flex;
}

/* New css added */
.main-wrapper {
  position: relative;
  width: 100%;
  background-color: #fafafa !important;
}

@media screen and (max-width: 1199px) {
  h2 {
    font-size: 29.6648px;
    line-height: 38px;
  }

  h3 {
    font-size: 32px;
    line-height: 32px;
  }

  h4 {
    font-size: 26px;
    line-height: 28px;
  }

  p {
    font-size: 16px;
  }

  h5 {
    font-size: 22px;
    line-height: 24px;
  }
}

@media screen and (max-width: 991px) {
  body {
    font-size: 16px;
    line-height: 24px;
  }

  h1 {
    font-size: 32px;
    line-height: 36px;
  }

  h3 {
    font-size: 26px;
    line-height: 32px;
  }

  h4 {
    font-size: 22px;
    line-height: 28px;
  }

  h5 {
    font-size: 20px;
    line-height: 24px;
  }

  h6 {
    font-size: 14px;
    line-height: 18px;
  }

  .btn {
    font-size: 16px;
    line-height: 20px;
  }

  #scrollTop {
    width: 40px;
    height: 40px;
    font-size: 26px;
  }

  .pattern {
    height: 53px;
    background-size: 200%;
  }
}

@media screen and (max-width: 767px) {
  .font-size-18 {
    font-size: 16px !important;
  }

  .font-size-20 {
    font-size: 18px !important;
  }

  .font-size-24 {
    font-size: 20px !important;
  }

  .carousel-control-next-icon,
  .carousel-control-prev-icon {
    display: none;
  }

  nav[aria-label="breadcrumb"]
    .custom-breadcrumb
    .breadcrumb-item
    + .breadcrumb-item {
    padding-left: 10px;
  }

  nav[aria-label="breadcrumb"]
    .custom-breadcrumb
    .breadcrumb-item
    + .breadcrumb-item::before {
    padding-right: 10px;
  }
}

@media screen and (max-width: 600px) {
  .dt-search .form-control {
    height: 40px;
    margin-right: 8px;
    font-size: 16px;
  }

  .dt-search .search-label {
    width: 36px;
    height: 36px;
    padding: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/userpenal/styles/common.css"],"names":[],"mappings":"AAEA;;;;;;;;;;;;;;;EAeE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,aAAa;AACb;;;;;;EAME,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,oBAAoB;EACpB,8BAA8B;EAC9B,8BAA8B;EAC9B,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,oBAAoB;EACpB,8BAA8B;EAC9B,oCAAoC;EACpC,yCAAyC;EACzC,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;;;EAGE,6BAA6B;EAC7B,cAAc;EACd,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,0CAA0C;AAC5C;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,UAAU;EACV,YAAY;EACZ,eAAe;EACf,WAAW;EACX,MAAM;EACN,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,sEAAsE;EACtE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kEAAkE;EAClE,YAAY;EACZ,OAAO;EACP,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,+EAA+E;EAC/E,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;;EAEE,UAAU;EACV,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;;AAGA;;GAEG,cAAc;AACjB;;AAEA;EACE,oEAAyE;AAC3E;AACA;EACE,oEAA0E;;AAE5E;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;;;EAKE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,aAAa;EACf;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;;;;IAIE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":["@import url(\"https://fonts.cdnfonts.com/css/lato\");\n\nbody,\nhtml,\nheader,\nfooter,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nul,\nli,\np,\nsection,\nmain {\n  margin: 0px;\n  padding: 0px;\n  display: block;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:focus-visible {\n  outline: -webkit-focus-ring-color auto 0px;\n}\n\nbutton:focus,\n.btn-close:focus,\n.btn-check:focus + .btn,\n.btn:focus,\n.accordion-button:focus,\n.form-check-input:focus,\n.form-control:focus {\n  box-shadow: none;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\na {\n  text-decoration: none;\n}\n\na,\nsvg,\ni {\n  transition: 0.6s all ease-in-out;\n}\n\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1280px;\n  }\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n\n.z-index-9 {\n  z-index: 9;\n}\n\n.inner-page {\n  margin-top: 120px;\n}\n\n.min-height-0 {\n  min-height: 0 !important;\n}\n\n.content {\n  display: none;\n}\n\n.max-width-auto {\n  max-width: inherit !important;\n}\n\n.bg-none {\n  background: none !important;\n}\n\n/*Typography*/\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 700 !important;\n}\n\nh1 {\n  font-size: 64px;\n  line-height: 67px;\n  font-weight: 900;\n}\n\nh2 {\n  font-size: 36px !important;\n  line-height: 35px;\n  color: #010404;\n}\n\nh2 span {\n  color: #163873;\n}\n\nh3 {\n  font-size: 36px;\n  line-height: 40px;\n}\n\nh4 {\n  font-size: 32px;\n  line-height: 48px;\n}\n\nh5 {\n  font-size: 26px;\n  line-height: 24px;\n}\n\nh6 {\n  font-size: 16px;\n  line-height: 20px;\n}\n\np {\n  color: var(--Black, #010404);\n  text-align: justify;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  margin-bottom: 17px;\n}\n\n.font-size-14 {\n  font-size: 14px;\n}\n\n.font-size-16 {\n  font-size: 16px !important;\n}\n\n.font-size-18 {\n  font-size: 18px !important;\n}\n\n.font-size-20 {\n  font-size: 20px !important;\n}\n\n.font-size-24 {\n  font-size: 24px !important;\n}\n\n.primary-color {\n  color: #549cac;\n}\n\n/*Button*/\n.btn {\n  border-radius: 10px;\n  padding: 13px 20px 12px;\n  transition: 0.6s all ease-in-out;\n}\n\n.btn:hover {\n  border: none;\n  background-color: #000;\n  color: #fff;\n}\n\n.btn_primary {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 20px !important;\n  border-radius: 10px !important;\n  background: #163873 !important;\n  color: var(--White, #fff) !important;\n  font-size: 16px !important;\n  font-style: normal !important;\n  font-weight: 700 !important;\n  line-height: normal !important;\n}\n\n.btn-common {\n  border-radius: 0px 0px 20px 20px !important;\n}\n\n.btn_secondary {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 20px !important;\n  border-radius: 10px !important;\n  border: 1px solid #163873 !important;\n  background: var(--White, #fff) !important;\n  color: #163873 !important;\n  font-size: 16px !important;\n  font-style: normal !important;\n  font-weight: 700 !important;\n  line-height: normal !important;\n}\n\n.btn.btn-donate {\n  background-color: #408817;\n}\n\n.btn.btn-donate:hover {\n  background-color: #419f0b;\n}\n\n.btn.btn-default {\n  background-color: #549cac;\n}\n\n.btn.btn-default:hover {\n  background-color: #c44d07;\n}\n\n.btn.btn-search {\n  background-color: #549cac;\n}\n\n.btn.btn-search:hover {\n  background-color: #403d3e;\n}\n\n.btn.btn-outline-default {\n  border: 2px solid #549cac;\n  color: #549cac;\n  text-transform: capitalize;\n}\n\n.btn.btn-outline-default:hover {\n  background-color: #c44d07;\n  border: 2px solid #c44d07;\n  color: #fff;\n}\n\n.btn.btn-outline-default svg {\n  fill: #549cac;\n  margin-left: 2px;\n}\n\n.btn.btn-outline-default:hover svg {\n  fill: #fff;\n}\n\n.ascending-btn {\n  transform: rotate(-180deg);\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n/*Custom Pagination*/\n.custom-pagination .pagination {\n  margin-top: 50px;\n}\n\n.custom-pagination .page-item:first-child .page-link,\n.custom-pagination .page-item:last-child .page-link {\n  border-radius: 0;\n  font-size: 16px;\n  border-top: 2px solid transparent;\n  display: flex;\n  align-items: center;\n}\n\n.custom-pagination .page-item:first-child .page-link svg {\n  fill: #9ca3af;\n  margin-right: 12px;\n}\n\n.custom-pagination .page-item:last-child .page-link svg {\n  fill: #9ca3af;\n  margin-left: 12px;\n}\n\n.custom-pagination .page-item:first-child .page-link:hover svg,\n.custom-pagination .page-item:last-child .page-link:hover svg {\n  fill: #549cac;\n}\n\n.custom-pagination .page-link {\n  border: 0;\n  border-radius: 0;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 600;\n  color: #6b7280;\n  border-top: 2px solid transparent;\n  padding: 16px 16px 0 16px;\n}\n\n.custom-pagination .page-link.active,\n.custom-pagination .page-link:hover,\n.custom-pagination .page-link:focus {\n  background-color: transparent;\n  color: #549cac;\n  border-top: 2px solid #549cac;\n}\n\n/*Custom Breadcrumb*/\nnav[aria-label=\"breadcrumb\"] {\n  max-width: 732px;\n  margin: 0px auto;\n}\n\nnav[aria-label=\"breadcrumb\"] .custom-breadcrumb .breadcrumb-item {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n}\n\nnav[aria-label=\"breadcrumb\"] .custom-breadcrumb .breadcrumb-item a {\n  color: #6b7280;\n}\n\nnav[aria-label=\"breadcrumb\"] .custom-breadcrumb .breadcrumb-item:hover a {\n  color: #549cac;\n}\n\nnav[aria-label=\"breadcrumb\"] .custom-breadcrumb .breadcrumb-item.active {\n  color: #549cac;\n}\n\nnav[aria-label=\"breadcrumb\"]\n  .custom-breadcrumb\n  .breadcrumb-item\n  + .breadcrumb-item::after {\n  content: var(--bs-breadcrumb-divider, \">\");\n}\n\nnav[aria-label=\"breadcrumb\"]\n  .custom-breadcrumb\n  .breadcrumb-item:last-child::after {\n  display: none;\n}\n\nnav[aria-label=\"breadcrumb\"]\n  .custom-breadcrumb\n  .breadcrumb-item\n  + .breadcrumb-item {\n  padding-left: 23px;\n}\n\nnav[aria-label=\"breadcrumb\"]\n  .custom-breadcrumb\n  .breadcrumb-item\n  + .breadcrumb-item::before {\n  padding-right: 23px;\n}\n\n/*Contact Form*/\n.contact-form .form-control {\n  background: #f9fdff;\n  border: 1px solid #d1d5db;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 6px;\n  font-size: 16px;\n  line-height: 24px;\n  height: 50px;\n  color: rgba(82, 84, 100, 0.8);\n}\n\n.contact-form .form-control::placeholder {\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(82, 84, 100, 0.8);\n}\n\n.contact-form .form-group {\n  margin-bottom: 24px;\n}\n\n/*Desktop Search*/\n.dt-search {\n  margin-bottom: 60px;\n}\n\n.dt-search .form-group {\n  display: flex;\n  align-items: center;\n}\n\n.dt-search .form-control {\n  font-size: 19px;\n  line-height: 24px;\n  color: #6b7280;\n  background: #f9fdff;\n  border: 1px solid #d1d5db;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 6px;\n  height: 57px;\n  margin-right: 17px;\n}\n\n.dt-search .search-label {\n  width: 52px;\n  height: 52px;\n  background: #549cac;\n  border-radius: 50%;\n  padding: 12px;\n  cursor: pointer;\n}\n\n.dt-search .search-label svg {\n  fill: #ffffff;\n}\n\n.dt-search .search-label:hover svg {\n  fill: #111827;\n}\n\n.form-select:focus {\n  box-shadow: none !important;\n  outline: 0 !important;\n}\n\n/*Sroll to top*/\n.scrollTop {\n  z-index: 99;\n  cursor: pointer;\n  border: none;\n  position: fixed;\n  bottom: 15px;\n  right: 15px;\n  width: 50px;\n  height: 50px;\n  font-size: 30px;\n  font-weight: bold;\n  text-align: center;\n  color: #ffffff;\n  background: #163873;\n  transition: 0.6s all ease-in-out;\n  border-radius: 40px;\n}\n\n.scrollTop:hover {\n  background: #221c1d;\n}\n\n.scrollTop .fa-angle-up {\n  color: #ffffff;\n  transition: 0.6s all ease-in-out;\n}\n\n.scrollTop:hover .fa-angle-up {\n  color: #ffffff;\n}\n\n.overlay {\n  background: rgba(26, 25, 25, 0.8);\n  width: 13%;\n  height: 100%;\n  position: fixed;\n  z-index: 99;\n  top: 0;\n  right: 0;\n  transition: 0.6s all ease-in-out;\n}\n\nhgroup.heading h3 {\n  color: #549cac;\n  margin-bottom: 16px;\n}\n\nhgroup.heading p {\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.btn-close {\n  right: 15px;\n  top: 15px;\n  z-index: 11;\n  /* background: transparent url(../images/icons/modal-close-btn.svg); */\n  padding: 0;\n  width: 40px;\n  height: 40px;\n  opacity: 1;\n}\n\n.pattern {\n  position: absolute;\n  width: 100%;\n  /* background: url(../images/pattern-img-1.png) no-repeat right; */\n  height: 88px;\n  left: 0;\n  bottom: 0;\n}\n\n.intervation-bg {\n  /* background: url(../images/intervation-bg.png) no-repeat; */\n  background-size: cover;\n  background-position: bottom;\n}\n\n.intervation-pattern {\n  /* background: url(../images/intervation-pattern.png) no-repeat right bottom; */\n  background-size: cover;\n  height: 80px;\n}\n\n.carousel-indicators [data-bs-target] {\n  width: 10px !important;\n  height: 10px !important;\n  background-color: #e5e7eb;\n  border-radius: 50%;\n  margin: 0 5px;\n  opacity: 1;\n  border: 5px solid transparent;\n  transition: 0.6s all ease-in-out;\n}\n\n/*Custom Carousel*/\n.carousel-control-next,\n.carousel-control-prev {\n  opacity: 1;\n  cursor: default;\n}\n\n.carousel-control-next:focus .carousel-control-next-icon,\n.carousel-control-next:hover .carousel-control-next-icon,\n.carousel-control-prev:focus .carousel-control-prev-icon,\n.carousel-control-prev:hover .carousel-control-prev-icon {\n  opacity: 0.8;\n}\n\n.carousel-control-next-icon,\n.carousel-control-prev-icon {\n  width: 58px;\n  height: 58px;\n  cursor: pointer;\n  position: absolute;\n  /* display: none ; */\n}\n\n\n.pic_item .carousel-control-prev, \n.pic_item .carousel-control-next {\n   display:  none;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"../../../images/customer/left-img.svg\") !important;\n}\n.carousel-control-next-icon {\n  background-image: url(\"../../../images/customer/right-img.svg\") !important;\n\n}\n.carousel-control-prev .carousel-items-icons {\n  display: none !important;\n}\n\na:link {\n  text-decoration: none;\n}\n\na:visited {\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: none;\n}\n\na:active {\n  text-decoration: none;\n}\n\n.css-1aquho2-MuiTabs-indicator {\n  background-color: #163873 !important;\n}\n\n.css-187mznn-MuiSlider-root {\n  color: #163873 !important;\n}\n.css-14owq8c-MuiButtonBase-root-MuiTab-root.Mui-selected {\n  color: #163873 !important;\n}\n\n.page-flex,\n.sidebar-user-img picture,\n.users-table picture {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n/* New css added */\n.main-wrapper {\n  position: relative;\n  width: 100%;\n  background-color: #fafafa !important;\n}\n\n@media screen and (max-width: 1199px) {\n  h2 {\n    font-size: 29.6648px;\n    line-height: 38px;\n  }\n\n  h3 {\n    font-size: 32px;\n    line-height: 32px;\n  }\n\n  h4 {\n    font-size: 26px;\n    line-height: 28px;\n  }\n\n  p {\n    font-size: 16px;\n  }\n\n  h5 {\n    font-size: 22px;\n    line-height: 24px;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  body {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  h1 {\n    font-size: 32px;\n    line-height: 36px;\n  }\n\n  h3 {\n    font-size: 26px;\n    line-height: 32px;\n  }\n\n  h4 {\n    font-size: 22px;\n    line-height: 28px;\n  }\n\n  h5 {\n    font-size: 20px;\n    line-height: 24px;\n  }\n\n  h6 {\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .btn {\n    font-size: 16px;\n    line-height: 20px;\n  }\n\n  #scrollTop {\n    width: 40px;\n    height: 40px;\n    font-size: 26px;\n  }\n\n  .pattern {\n    height: 53px;\n    background-size: 200%;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .font-size-18 {\n    font-size: 16px !important;\n  }\n\n  .font-size-20 {\n    font-size: 18px !important;\n  }\n\n  .font-size-24 {\n    font-size: 20px !important;\n  }\n\n  .carousel-control-next-icon,\n  .carousel-control-prev-icon {\n    display: none;\n  }\n\n  nav[aria-label=\"breadcrumb\"]\n    .custom-breadcrumb\n    .breadcrumb-item\n    + .breadcrumb-item {\n    padding-left: 10px;\n  }\n\n  nav[aria-label=\"breadcrumb\"]\n    .custom-breadcrumb\n    .breadcrumb-item\n    + .breadcrumb-item::before {\n    padding-right: 10px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .dt-search .form-control {\n    height: 40px;\n    margin-right: 8px;\n    font-size: 16px;\n  }\n\n  .dt-search .search-label {\n    width: 36px;\n    height: 36px;\n    padding: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
